import type { ReactNode } from "react";

import { MenuItem } from "@skilitics/designer-ui-components";

import type { DesignerNode } from "../../../types";
import { useBrowseTemplates } from "../../templates";

interface Props {
  node: DesignerNode;
  children: ReactNode;
}

export const BrowseTemplatesAndReplaceMenuItem = ({ node, children }: Props) => {
  const handleBrowse = useBrowseTemplates({
    target: { slotResidentNodeId: node.id },
    criteria: { typeId: node.typeId },
  });

  return <MenuItem onClick={handleBrowse}>{children}</MenuItem>;
};
